import React, { forwardRef, useState } from 'react';
import { SendGlyph } from '../chatIcons';
import classes from './ChatComposer.module.css';

const MAX_LENGTH = 500;

/** The comment input and send button; hands trimmed text to `onSend`. The ref is the input. */
const ChatComposer = forwardRef(function ChatComposer({ onSend }, inputRef) {
    const [draft, setDraft] = useState('');
    const canSend = draft.trim().length > 0;

    const handleSubmit = (event) => {
        event.preventDefault();
        const text = draft.trim();
        if (!text) return;
        onSend(text);
        setDraft('');
        inputRef.current?.focus();
    };

    return (
        <form onSubmit={handleSubmit} className={classes.composer}>
            <input
                className={classes.input}
                ref={inputRef}
                type="text"
                value={draft}
                onChange={(event) => setDraft(event.target.value)}
                placeholder="Write a comment…"
                aria-label="Write a comment"
                maxLength={MAX_LENGTH}
            />
            <button type="submit" className={classes.sendButton} disabled={!canSend} aria-label="Send comment" title="Send comment">
                <SendGlyph />
            </button>
        </form>
    );
});

export default ChatComposer;
